var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLinkItem3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 15.1111L0 12.0001L16 2.66675L32 12.0001V23.3334H29.3333V13.5557L26.6667 15.1111V24.0151L26.3699 24.3819C23.9276 27.3999 20.1891 29.3334 16 29.3334C11.8109 29.3334 8.07239 27.3999 5.63017 24.3819L5.33333 24.0151V15.1111ZM8 16.6667V23.0557C9.95628 25.2721 12.8148 26.6667 16 26.6667C19.1852 26.6667 22.0437 25.2721 24 23.0557V16.6667L16 21.3334L8 16.6667ZM5.29236 12.0001L16 18.2462L26.7076 12.0001L16 5.75396L5.29236 12.0001Z",
    fill: "#26539C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkItem3);
export default __webpack_public_path__ + "static/media/icon_link_item3.8b55154a79d11870c7cce03da3809e77.svg";
export { ForwardRef as ReactComponent };